import React from 'react';
import { Flex } from 'lib/components/Flex';
import { ReportsMenu } from './components/ReportsMenu/ReportsMenu';
import { SystemError } from 'components/SystemError/SystemError';
import { Outlet } from 'react-router-dom';

export function ReportsView() {
    return (
        <Flex column>
            <ReportsMenu />
            <SystemError />
            <Outlet />
        </Flex>
    );
}

ReportsView.displayName = 'ReportsView';
ReportsView.whyDidYouRender = true;
